import { useErrorBoundary } from "preact/hooks";
import { useTranslationContext } from "../context/translation.js";
import { useNotificationContext } from "../context/notification.js";

export function useRenderErrorReport(appInfo: {
  version: string;
  hash: string;
}) {
  const { i18n } = useTranslationContext();
  const { displayError } = useNotificationContext();
  const [failed] = useErrorBoundary((error) => {
    if (error) {
      const description = i18n.str`An unexpected error occurred and was not handled properly. To report it, copy the details and create an issue at https://bugs.taler.net.`;
      displayError(
        i18n.str`Render error.`,
        {
          error: convert(error),
          location: window.location.href,
          appInfo,
          when: new Date().toUTCString(),
        },
        description,
      );
      console.log(description);
      console.log(JSON.stringify(error, Object.getOwnPropertyNames(error), 2));
    }
  });
  return failed !== undefined;
}

function convert(error: any) {
  if (error instanceof Error) {
    return {
      name: error.name,
      message: error.message,
      stack: error.stack?.split("\n"),
    };
  }
  return error;
}
